// extracted by mini-css-extract-plugin
module.exports = {"main":"PeopleSocialMediaIcon_main__0H5OD","icon":"PeopleSocialMediaIcon_icon__cmqOQ","search-fade-in":"PeopleSocialMediaIcon_search-fade-in__Dmmm6"};